module.exports = __webpack_public_path__ + "static/img/GN.548651f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/GN.png
// module id = iWE5
// module chunks = 34